/*
 * @Author: Teemo Ding
 * @Date: 2021-11-02 13:22:02
 * @LastEditTime: 2022-06-10 09:55:12
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/order/index.ts
 */
import { OrderListPage } from '@/src/types/common/order';
import { get, post, print, remove } from 'src/tools/server';

const getOrder = (uuid?: string) => {
  return get(`/portal/orderPage/${uuid}`, {});
};

const getShipmentInfo = (uuid) => {
  return <any>get(`/portal/order/parcel/shippingPage/${uuid}`, {});
};

const generateWaybill = (data) => {
  return post(`/portal/order/parcel/generateWaybill`, data || {}, {});
};
const confirmWaybill = (data) => {
  return post(`/portal/order/parcel/confirmWaybill`, data || {}, {});
};

const getParcel = (uuid?: string) => {
  return get(`/portal/order/parcel/${uuid}`, {});
};

const undoParcel = (uuid?: string) => {
  return get(`/portal/order/parcel/undo/${uuid}`, {});
};

const pickOrder = (body) => {
  return post(`/portal/order/parcel/pick`, body, {});
};

const packParcel = (body) => {
  return post(`/portal/order/parcel/pack`, body, {});
};

const orderInit = (startIndex, pageCount, data) => {
  return post<OrderListPage>(
    `/portal/ordersPage/${startIndex}/${pageCount}`,
    data,
    {},
  );
};

const getOrders = (startIndex, pageCount, body) => {
  return post<any>(
    `/portal/orders/${startIndex || 0}/${pageCount || 10}`,
    body,
    {},
  );
};

const printInvoice = (body) => {
  return print.post(`/portal/orders/print/invoices`, body, {
    returnWholeData: true,
    responseType: 'arraybuffer',
  });
};

const printCourierLabel = (body) => {
  return print.post(`/portal/orders/print/courierLabels`, body, {
    returnWholeData: true,
    responseType: 'arraybuffer',
  });
};
const printParcelCourierLabel = (parcelUuid) => {
  return print.get(`/portal/order/parcel/${parcelUuid}/print/courierLabel`, {
    returnWholeData: true,
    responseType: 'arraybuffer',
  });
};
const printPackingSlip = (parcelUuid) => {
  return print.get(`/portal/order/parcel/${parcelUuid}/print/packingSlip`, {
    returnWholeData: true,
    responseType: 'arraybuffer',
  });
};

const saveInternalRemark = (body) => {
  return post<any>(`/portal/order/remark`, body, {});
};
const notifyCustomer = (uuid, body) => {
  return post<any>(`/portal/order/parcel/notify/${uuid}`, body, {});
};

const collectWithPin = (body) => {
  return post<any>(`/portal/order/parcel/clickCollect/pin`, body, {
    returnWholeData: true,
    handleErrorAsResolve: true,
  });
};

const collectWithQRCode = (body) => {
  return post<any>(`/portal/order/parcel/clickCollect/code`, body, {
    returnWholeData: true,
    handleErrorAsResolve: true,
  });
};
const getBillingAddress = (orderUuid) => {
  return get<any>(`/portal/order/${orderUuid}/billingAddress`, {});
};
const saveBillingAddress = (orderUuid, body) => {
  return post<any>(`/portal/order/${orderUuid}/billingAddress`, body, {});
};
const clickCollectByCode = (body) => {
  return post<any>(`/portal/order/parcel/clickCollectByCode`, body, {});
};
const getSender = (orderUuid) => {
  return get<any>(`/portal/order/${orderUuid}/sender`, {});
};
const saveSender = (orderUuid, body) => {
  return post<any>(`/portal/order/${orderUuid}/sender`, body, {});
};
const clickCollectByPIN = (body) => {
  return post<any>(`/portal/order/parcel/clickCollectByPIN`, body, {});
};

const markDelivered = (parcelUuid) => {
  return get<any>(`/portal/order/parcel/markDelivered/${parcelUuid}`, {});
};

const getBuyer = (orderUuid) => {
  return get<any>(`/portal/order/${orderUuid}/buyer`, {});
};
const saveBuyer = (orderUuid, data) => {
  return post<any>(`/portal/order/${orderUuid}/buyer`, data, {
    returnWholeData: true,
    handleErrorAsResolve: true,
  });
};

const getRecipient = (orderUuid) => {
  return get<any>(`/portal/order/${orderUuid}/recipient`, {});
};
const saveRecipient = (orderUuid, data) => {
  return post<any>(`/portal/order/${orderUuid}/recipient`, data, {});
};
const getZones = (orderUuid, data) => {
  return get<any>(`/portal/order/${orderUuid}/locker/zones`, { params: data });
};

const getPartners = (orderUuid, data, params) => {
  return post<any>(`/portal/order/${orderUuid}/locker/partners`, data, {
    params: params,
  });
};
const getPickups = (orderUuid, data) => {
  return get<any>(`/portal/order/${orderUuid}/pickup`, { params: data });
};

const getLocation = (countryCode, locale) => {
  return get<any>(`/portal/order/location/${countryCode}/${locale}`, {});
};
const getDeliveryMethods = (orderUuid, data) => {
  return post<any>(`/portal/order/${orderUuid}/deliveryMethods`, data, {});
};

const getGiftCards = (from, count, body) => {
  return post<any>(`/portal/order/giftCard/search/${from}/${count}`, body, {});
}; //

const getGiftCard = (uuid) => {
  return get<any>(`/portal/order/giftCard/detail/${uuid}`, {});
};

const updateGiftCardStatus = (body) => {
  return post<any>(`/portal/order/giftCard/status`, body, {});
};

const postGiftContact = (body) => {
  ///portal/order/giftCard/contact
  return post<any>(`/portal/order/giftCard/contact`, body, {});
};

const notifyAreaCode = (uuid) => {
  return get(`/portal/order/giftCard/notify/${uuid}`, {});
};

const getSubscriptionListInit = (from, count, body) => {
  return post<any>(
    `/portal/subscription/ordersPage/${from}/${count}`,
    body,
    {},
  );
};

const getSubscriptionList = (from, count, body) => {
  return post<any>(`/portal/subscription/orders/${from}/${count}`, body, {});
};

const getShoppingCartTemplateList = (from, count, body) => {
  return post<any>(
    `/portal/order/shoppingCartTemplates/${from}/${count}`,
    body,
    {},
  );
};

const getShoppingCartTemplates = (from, count, body) => {
  return post<any>(
    `/portal/order/shoppingCartTemplateList/${from}/${count}`,
    body,
    {},
  );
};

const markAsPaid = (orderUuid, body) => {
  return post<any>(`/portal/order/${orderUuid}/markAsPaid`, body, {});
};

const additionalPromoCode = (orderUuid, promoCode) => {
  return get<any>(
    `/portal/order/additionalPromoCode/${orderUuid}/${promoCode}`,
    {},
  );
};

const deleteAdditionalPromoCode = (orderUuid, promoCode) => {
  return remove<any>(
    `/portal/order/additionalPromoCode/${orderUuid}/${promoCode}`,
    {},
  );
};

const notifyVirtualItem = (orderLineItemUuid, params?) => {
  return get<any>(`/portal/order/virtualItem/notify/${orderLineItemUuid}`, {
    params: params || {},
  });
};
const markAsDoneVirtualItem = (orderLineItemUuid) => {
  return get<any>(
    `/portal/order/virtualItem/service/markAsDone/${orderLineItemUuid}`,
    {},
  );
};
const undoVirtualItemService = (orderLineItemUuid) => {
  return get<any>(
    `/portal/order/virtualItem/service/undo/${orderLineItemUuid}`,
    {},
  );
};
const getInvoice = (orderUuid) => {
  return get<any>(`/portal/order/${orderUuid}/invoice`, {});
};

const testInvoice = (printingPageSize, downloadable?) => {
  return downloadable
    ? print.get(`/portal/setting/store/invoice/test/${printingPageSize}`, {
        returnWholeData: true,
        responseType: 'arraybuffer',
      })
    : get(`/portal/setting/store/invoice/test/${printingPageSize}`, {
        returnWholeData: true,
        responseType: 'arraybuffer',
      });
};

const saveInvoice = (orderUuid, data) => {
  return post<any>(`/portal/order/${orderUuid}/invoice`, data, {});
};
const deleteInvoice = (orderUuid) => {
  return remove<any>(`/portal/order/${orderUuid}/invoice`, {});
};
const cancelOrder = (data) => {
  return post<any>(`/portal/order/cancel`, data, {});
};

const setEarliestShippingDate = (data) => {
  return post<any>(`/portal/order/earliestShippingDate`, data, {});
};

export {
  additionalPromoCode,
  cancelOrder,
  clickCollectByCode,
  clickCollectByPIN,
  collectWithPin,
  collectWithQRCode,
  confirmWaybill,
  deleteAdditionalPromoCode,
  deleteInvoice,
  generateWaybill,
  getBillingAddress,
  getBuyer,
  getDeliveryMethods,
  getGiftCard,
  getGiftCards,
  getInvoice,
  getLocation,
  getOrder,
  getOrders,
  getParcel,
  getPartners,
  getPickups,
  getRecipient,
  getSender,
  getShipmentInfo,
  getShoppingCartTemplateList,
  getShoppingCartTemplates,
  getSubscriptionList,
  getSubscriptionListInit,
  getZones,
  markAsDoneVirtualItem,
  markAsPaid,
  markDelivered,
  notifyAreaCode,
  notifyCustomer,
  notifyVirtualItem,
  orderInit,
  packParcel,
  pickOrder,
  postGiftContact,
  printCourierLabel,
  printInvoice,
  printPackingSlip,
  printParcelCourierLabel,
  saveBillingAddress,
  saveBuyer,
  saveInternalRemark,
  saveInvoice,
  saveRecipient,
  saveSender,
  setEarliestShippingDate,
  testInvoice,
  undoParcel,
  undoVirtualItemService,
  updateGiftCardStatus,
};
